/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['services/utils'], function(Utils) {
    'use strict';
    return {
        fillInTiles512Options: function(options) {
            if (options.tileSize === 512) {
                options.zoomOffset -= 1;
                options.minZoom = options.minZoom > 0 ? options.minZoom - 1 : 0;
            }
        },
        fillInSubdomainsOptions: function(options) {
            if (Utils.isString(options.subdomains)) {
                options.subdomains = options.subdomains.split('');
            }
        }
    };
});



// WEBPACK FOOTER //
// ./display/layers/optionsComplementor.js